export default "__VITE_ASSET__DnVSW$Pa__"